import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { shortenStringWithTooltip } from '../../helper';
import CustomTooltip from '../../Tooltip/CustomTooltip';
import { CareUserContext } from '../../../Pages/Library/UserInstructionLibrary/provider/careUserContext';

function UserInstructionGroupCard({ dataItem, handleDeleteMultiple, handleEdit, handleGroupCardSelected, isChecked, subBrandAccess }) {
  const { t } = useTranslation('common');
  const { CareAddEditAccess, CareDeleteAccess } = useContext(CareUserContext);
  return (
    <div className="col-lg-3 care-container item-list" key={dataItem?._id}>
      <div className="common-listing-card card">
        <div className="card-header">
          <ul className="card-header-icon">
            {CareDeleteAccess && (
              <li>
                <div className="common-checkbox">
                  <input
                    onChange={() => handleGroupCardSelected(dataItem?._id)}
                    name={`check_${dataItem?._id}`}
                    id={`check_${dataItem?._id}`}
                    type="checkbox"
                    checked={isChecked(dataItem?._id)}
                  />
                  <label htmlFor={`check_${dataItem?._id}`} className="chklabel" />
                </div>
              </li>
            )}
            {CareAddEditAccess && (
              <li>
                <CustomTooltip placement="top" tooltipText={t('COLOR_WAY_CARD.EDIT')}>
                  <button type="button" aria-label="edit-button" className="btn p-0" onClick={handleEdit}>
                    <i className="icon-Edit-1 f-22" />
                  </button>
                </CustomTooltip>
              </li>
            )}
            {CareDeleteAccess && (
              <li>
                <CustomTooltip placement="top" tooltipText={t('COLOR_WAY_CARD.DELETE')}>
                  <button type="button" aria-label="button" className="btn p-0" onClick={() => handleDeleteMultiple(dataItem?._id)}>
                    <i className="icon-Delete f-24" />
                  </button>
                </CustomTooltip>
              </li>
            )}
            <li>
              <div className="info-container xs-position-absolute d-flex text-left p-0 ">
                <span className="icon-Information f-22" />
                <div className="info-content">
                  <p className="mb-0">
                    <b>{t('COLOR_WAY_CARD.CREATED_BY_DATE_TIME')}&nbsp;</b>
                    <span>{`${dataItem?.createdBy || ''} ${dataItem?.createdAt && moment(dataItem?.createdAt).format('DD-MMMM-YYYY, HH:mm:ss a')}`}</span>
                  </p>
                  {dataItem?.modifiedBy && (
                    <p className="mb-0">
                      <b>{t('COLOR_WAY_CARD.MODIFIED_BY_DATE_TIME')}&nbsp;</b>
                      <span>{`${dataItem?.modifiedBy || ''} ${
                        (dataItem?.updatedAt && moment(dataItem?.updatedAt).format('DD-MMMM-YYYY, HH:mm:ss a')) || ''
                      }`}</span>
                    </p>
                  )}
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="card-body">
          <h4 className="grp-title">{dataItem?.name}</h4>
          <ul className="card-ul">
            <li>
              <span>
                <strong>{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.PRODUCT_TYPE')}: </strong>
                {dataItem?.productType ? shortenStringWithTooltip(dataItem?.productType?.map((e) => e?.label)?.join(', '), 30) : ''}
              </span>
            </li>
            <li>
              <span>
                <strong>{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.BRAND')}: </strong>
                {dataItem?.brandIds ? shortenStringWithTooltip(dataItem?.brandIds?.map((e) => e?.label)?.join(', '), 30) : ''}
              </span>
            </li>
            {subBrandAccess && (
              <li>
                <span>
                  <strong>{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SUB_BRAND')}: </strong>
                  {dataItem?.subBrandIds ? shortenStringWithTooltip(dataItem?.subBrandIds?.map((e) => e?.label)?.join(', '), 30) : ''}
                </span>
              </li>
            )}

            <li>
              <span>
                <strong>{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.CAT_ONE')}: </strong>
                {dataItem?.catOneIds ? shortenStringWithTooltip(dataItem?.catOneIds?.map((e) => e?.label)?.join(', '), 30) : ''}
              </span>
            </li>
            <li>
              <span>
                <strong>{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.CAT_TWO')}: </strong>
                {dataItem?.catTwoIds ? shortenStringWithTooltip(dataItem?.catTwoIds?.map((e) => e?.label)?.join(', '), 26) : ''}
              </span>
            </li>
            <li>
              <span>
                <strong>{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.CAT_THREE')}: </strong>
                {dataItem?.catThreeIds ? shortenStringWithTooltip(dataItem?.catThreeIds?.map((e) => e?.label)?.join(', '), 26) : ''}
              </span>
            </li>
            <li>
              <span>
                <strong>{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.CAT_FOUR')}: </strong>
                {dataItem?.catFourIds ? shortenStringWithTooltip(dataItem?.catFourIds?.map((e) => e?.label)?.join(', '), 26) : ''}
              </span>
            </li>
            <li>
              <span>
                <strong>{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.ADDITIONAL_INFO')}: </strong>
                {dataItem?.additonalInformation ? shortenStringWithTooltip(dataItem?.additonalInformation, 25) : ''}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default UserInstructionGroupCard;
